"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkLogo = exports.makeSuperSVG = void 0;
var material_1 = require("@mui/material");
var Link_1 = __importDefault(require("atomicComponents/atoms/Text/Link"));
var general_1 = require("utils/general");
var makeSuperSVG = function (SvgComp) { return (0, material_1.styled)(SvgComp, {
    shouldForwardProp: (0, general_1.omitProps)('width', 'height', 'disabled', 'brandColor'),
})(function (_a) {
    var _b;
    var height = _a.height, width = _a.width, disabled = _a.disabled, brandColor = _a.brandColor, theme = _a.theme;
    return (__assign({ height: height !== null && height !== void 0 ? height : 'auto', width: width !== null && width !== void 0 ? width : 'auto', margin: theme.spacing(0.625), '& path': { transition: 'fill 250ms cubic-bezier(0.4, 0, 0.2, 1)' } }, disabled
        ? {
            cursor: 'not-allowed',
            '& path:not(.skip)': { fill: theme.palette.grey[300] },
        }
        : {
            '& path:not(.skip)': __assign({ fill: (_b = theme.palette.neutral) === null || _b === void 0 ? void 0 : _b.main }, brandColor && { '&:hover path:not(.skip)': { fill: brandColor } }),
        }));
}); };
exports.makeSuperSVG = makeSuperSVG;
exports.LinkLogo = (0, material_1.styled)(Link_1.default, { shouldForwardProp: (0, general_1.omitProps)('brandColor') })(function (_a) {
    var brandColor = _a.brandColor;
    return (__assign({}, brandColor && {
        ':hover:not([disabled]) svg > path:not(.skip)': {
            fill: brandColor,
        },
    }));
});
